import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Img, VideoWrapper, Video } from "./styles"
import Grid from "../../grid"
import { H2, P } from "../../typography"
import Lightbox from "yet-another-react-lightbox"
import Counter from "yet-another-react-lightbox/plugins/counter"
import "yet-another-react-lightbox/styles.css"
import "yet-another-react-lightbox/plugins/counter.css"

const PhotosAndVideos = ({ photos, video_url }) => {
  const [open, setOpen] = useState(false)
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0)
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768)

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768)
    }
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleOpen = (index) => {
    if (isDesktop) {
      setOpen(true)
      setCurrentPhotoIndex(index)
    }
  }

  return (
    <Grid gap="32px">
      <Grid gap="24px">
        <H2 variant="primary" size="profile" marginless>
          Videos
        </H2>
        {video_url ? (
          <>
            <Grid gap="4px" template="auto / 1fr 1fr">
              <VideoWrapper>
                <Video
                  title="Video"
                  width="560"
                  height="349"
                  src={`${video_url}?color=white&rel=0`}
                  allowFullScreen
                  frameBorder="0"
                />
              </VideoWrapper>
            </Grid>
          </>
        ) : (
          <P variant="content" marginless profileData>
            No videos available.
          </P>
        )}
      </Grid>

      <Grid gap="24px">
        <H2 variant="primary" size="profile" marginless>
          Photos
        </H2>
        <Grid gap="12px">
          {photos.length > 0 ? (
            <>
              <Grid gap="4px" template="auto / 1fr 1fr 1fr">
                {photos.map((image, index) => (
                  <Img key={index} src={image.url} alt={image.alt} onClick={() => handleOpen(index)} />
                ))}
              </Grid>
            </>
          ) : (
            <P variant="content" marginless profileData>
              No photos available.
            </P>
          )}
        </Grid>
      </Grid>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={photos.map((photo) => ({ src: photo.url }))}
        index={currentPhotoIndex}
        styles={{ container: { backgroundColor: "rgba(0, 0, 0, .8)" } }}
        plugins={[Counter]}
      />
    </Grid>
  )
}

PhotosAndVideos.propTypes = {
  photos: PropTypes.array.isRequired,
  video_url: PropTypes.string
}

PhotosAndVideos.defaultProps = {
  photos: [],
  video_url: ""
}

export default PhotosAndVideos
